import React from 'react';

import { AccentBadge } from './accent-badge';
import { FilledAccentBadge, StyledLockIcon, StyledLockUnlockedIcon } from './badges.styled';
import { theme } from './theme';
import { IBadgeProps, IPlatformBadgeProps, ITimeLeftBadgeProps } from './types';

export { LoginRequiredBadge } from './login-required-badge';

export const NewOfferBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <AccentBadge data-testid="new-offer-badge">{formatMessage({ id: 'newOffer' })}</AccentBadge>
);

export const PlatformBadge: React.FC<IPlatformBadgeProps> = ({ platform, formatMessage }) => {
  const platformOnlyString = formatMessage({ id: 'platformOnly' }, { platform });
  return <AccentBadge data-testid="platform-badge">{platformOnlyString}</AccentBadge>;
};

export const TimeLeftBadge: React.FC<ITimeLeftBadgeProps> = ({ days, formatMessage }) => {
  const displayDaysLeft = days !== undefined && days > 0;

  if (!displayDaysLeft) {
    return null;
  }

  const timeLeftString = formatMessage({ id: 'days' }, { days });
  return (
    <AccentBadge data-testid="time-left-badge">
      {theme.expiresPrefix} {timeLeftString}
    </AccentBadge>
  );
};

export const LockedPromoCodeOfferBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <FilledAccentBadge
    $fillColor={theme.lockedPromoCodeOfferFillColor}
    data-testid="locked-promo-code-offer-badge"
  >
    <StyledLockIcon data-testid="promo-code-offer-badge-locked-icon" />
    <span>{formatMessage({ id: 'lockedPromoCodeOffer' })}</span>
  </FilledAccentBadge>
);

export const UnlockedPromoCodeOfferBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <FilledAccentBadge
    $textColor={Styles.color.grey.three}
    $fillColor={Styles.color.grey.five}
    data-testid="unlocked-promo-code-offer-badge"
  >
    <StyledLockUnlockedIcon
      $iconColor={Styles.color.grey.three}
      data-testid="promo-code-offer-badge-unlocked-icon"
    />
    <span>{formatMessage({ id: 'unlockedPromoCodeOffer' })}</span>
  </FilledAccentBadge>
);
